import { render, staticRenderFns } from "./MarketingPreferences.vue?vue&type=template&id=37ce6b51&"
import script from "./MarketingPreferences.vue?vue&type=script&lang=js&"
export * from "./MarketingPreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports